import React from 'react';
import { GradientTextAction } from 'src/common/GradientText';
import { EventForm } from './comps';
import { useFormikContext } from 'formik';
import { EventCompletionStatus, EventInput } from 'src/graphql/_generated';
import { Spacer } from 'src/common';
import Button from 'src/components/form/Button';

interface FromNewProps {
  eventId: string | null;
}

export const FromNew: React.FC<FromNewProps> = ({ eventId }) => {
  const { values, isSubmitting, setFieldValue, dirty, handleSubmit, isValid } = useFormikContext<{
    actions: EventInput[];
  }>();

  return (
    <>
      <EventForm editMode={!!eventId} />
      {!eventId && (
        <>
          <Spacer $px={20} />
          <GradientTextAction
            weight={500}
            px={14}
            onClick={() =>
              setFieldValue('actions', [
                ...values.actions,
                {
                  notes: '',
                  assignedTo: { text: '' },
                  dueDate: '',
                  completionStatus: EventCompletionStatus.Open,
                  completedAt: null,
                },
              ])
            }
            data-cy="add-action-btn"
            $disabled={isSubmitting}
          >
            + <span className="underline">Add another action</span>
          </GradientTextAction>
        </>
      )}
      <Spacer $px={32} />
      <Button
        primary
        style={{ width: '100%' }}
        onClick={() => handleSubmit()}
        disabled={!isValid || isSubmitting || !dirty}
        data-cy="submit-btn"
      >
        {eventId ? 'UPDATE' : 'ADD'}
      </Button>
    </>
  );
};
